module.exports = "<button class=\"btn btn-danger\" (click)=\"pedirConfirmacion()\">\r\n Disable\r\n</button>"


//////////////////
// WEBPACK FOOTER
// D:/a/1/s/BackOffice/SOC/SxSoc.ClientWeb/src/app/helpers/components/deleteEntity/deleteEntity.component.html
// module id = ../../../../../src/app/helpers/components/deleteEntity/deleteEntity.component.html
// module chunks = main